import React, { useEffect, useState } from "react";

const CountdownTimer = ({ startDate }) => {
  const [timeRemaining, setTimeRemaining] = useState("");
  
  useEffect(() => {
    const updateRemainingTime = () => {
      // Use UTC for current time
      const now = new Date();
      const nowUTC = Date.UTC(
        now.getUTCFullYear(),
        now.getUTCMonth(),
        now.getUTCDate(),
        now.getUTCHours(),
        now.getUTCMinutes(),
        now.getUTCSeconds()
      );
      
      // Parse startDate as UTC
      const targetDate = new Date(startDate);
      const targetUTC = Date.UTC(
        targetDate.getUTCFullYear(),
        targetDate.getUTCMonth(),
        targetDate.getUTCDate(),
        targetDate.getUTCHours(),
        targetDate.getUTCMinutes(),
        targetDate.getUTCSeconds()
      );
      
      const difference = targetUTC - nowUTC;

      if (difference > 0) {
        // Calculate day, hour, minutes, and seconds
        const day = Math.floor(difference / (1000 * 60 * 60 * 24));
        const hour = Math.floor((difference % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60));
        const minutes = Math.floor((difference % (1000 * 60 * 60)) / (1000 * 60));
        const seconds = Math.floor((difference % (1000 * 60)) / 1000);

        // Format the remaining time
        let remainingTime = "";
        if (day > 0) {
          remainingTime += `${day}d `;
        }
        remainingTime += `${hour.toString().padStart(2, '0')}h ${minutes.toString().padStart(2, '0')}m ${seconds.toString().padStart(2, '0')}s`;

        setTimeRemaining(remainingTime);
      } else {
        setTimeRemaining("Event has started");
      }
    };

    // Update every second
    const timer = setInterval(updateRemainingTime, 1000);
    updateRemainingTime(); // Call once to set initial state

    return () => clearInterval(timer); // Cleanup on component unmount
  }, [startDate]);

  return <span>{timeRemaining}</span>;
};

export default CountdownTimer;